<template>
	<div class="ce-button">
		<a @click="goToPage('/' + objectdata.url)" class="btn btn-circle">
			<span>{{objectdata.linkTitle}}</span>
		</a>
	</div>
</template>
<script>
	import Base from "./Base.vue";
	export default {
		extends: Base,
		props: {
			type: false,
			objectdata: {}
		},

		data() {
			return {};
		},
		created() {
			// this.init();
		},
		methods: {
			goToPage(path) {
				this.$router.push(path);
			}
		},
		composed: {}
	};
</script>

<style lang="scss">
</style>